import {useContext} from "react";
import {useNavigate} from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
// -
import NavQuestion from "./NavQuestion";
import NavMessages from "./NavMessages";
import NavPanel from "./NavPanel";
import NavUser from "./NavUser";

import AuthContext from "context/AuthContext";
import ThemeContext from "context/ThemeContext";

const TopBar = (data) => {
    let {user} = useContext(AuthContext);
    let {theme} = useContext(ThemeContext);
    const navigate = useNavigate();
    const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";

    return user ? (
        !user.organization || !user.panel ? (
            navigate("notorgpanel/")
        ) : (
            <Navbar bg="primary" expand="lg" className="top-navbar pt-0 pb-0" fixed="top">
                <Container fluid={true}>
                    <Navbar.Brand href="/">
                        <img
                            src={theme.logoTopbar || `${urlStatic}/images/quamtra_manager-white.svg`}
                            height="30"
                            className="d-inline-block align-top"
                            alt="Logo"
                            onError={(e) => {
                                console.error("Error loading topbar logo:", theme.logoTopbar);
                                e.target.src = `${urlStatic}/images/quamtra_manager-white.svg`;
                            }}
                        />
                    </Navbar.Brand>
                    <NavPanel />
                    <Nav className="d-flex justify-content-between ms-auto">
                        <NavMessages />
                        <NavQuestion />
                        <NavUser />
                    </Nav>
                </Container>
            </Navbar>
        )
    ) : (
        <></>
    );
};
export default TopBar;
